import { useState, useEffect, createContext, useContext } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import axios from "axios";
import { Toaster } from "sonner";

import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import GetQuotePage from "./pages/GetQuotePage";
import CarsForSalePage from "./pages/CarsForSalePage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Brand assets
export const BRAND = {
  logo: "https://customer-assets-eiarnc6j.emergentagent.net/job_car-inventory-hub-4/artifacts/c8de477fbb84576e_Quality%20Towing%20%26%20Transport%20Logo.webp",
  logoPromo: "https://customer-assets-eiarnc6j.emergentagent.net/job_car-inventory-hub-4/artifacts/f9b0e4184292a719_Quality%20Towing%20%26%20Transport%20Logo%20%281%29.webp",
  logoAlt: "https://customer-assets-eiarnc6j.emergentagent.net/job_car-inventory-hub-4/artifacts/12db82909112d184_Quality%20Towing%20%26%20Transport%20Logo%20%282%29.png",
  phone: "352-638-2284",
  phoneHref: "tel:3526382284",
  email: "qualitynationalservices@gmail.com",
  emailHref: "mailto:qualitynationalservices@gmail.com",
  name: "Quality Towing & Transport",
  owner: "Shabi",
};

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => { checkAuth(); }, []);

  const checkAuth = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) { setLoading(false); return; }
      const response = await axios.get(`${API}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true,
      });
      setUser(response.data);
    } catch (error) {
      localStorage.removeItem("token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    const response = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
    localStorage.setItem("token", response.data.token);
    setUser(response.data);
    return response.data;
  };

  const logout = async () => {
    try {
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
    } catch (e) {}
    localStorage.removeItem("token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="spinner"></div>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <Toaster position="top-right" toastOptions={{
          style: { background: '#fff', color: '#000', border: '1px solid rgba(0,0,0,0.1)' },
        }} />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/get-quote" element={<GetQuotePage />} />
            <Route path="/cars-for-sale" element={<CarsForSalePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </div>
    </AuthProvider>
  );
}

export default App;
